exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indented[data-v-5a546758]{margin:20px;max-width:550px}.spacer[data-v-5a546758]{height:15px;border:0 solid #000}.spaced[data-v-5a546758]{margin-bottom:10px}.button[data-v-5a546758]{border:1px solid gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a546758","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_AddRootNode.vue
// module id = 191
// module chunks = 0